module.exports = __webpack_public_path__ + "a9dcd35662fed273122695229b6df9f8.png";